import React from 'react';
import { FIG_INK, FIG_TEXT, FIG_RED } from '../figureStyle';
import {
  VX, VW, VH, PLOT_L, PLOT_R, LEVELS, LABEL_FS, LABEL_LH,
} from './simpleTakeoffLayout';
import {
  SMOOTH_CURVE, smoothTakeoffPath, type SmoothCurveParams,
} from './simpleTakeoffCurves';

// ─── Smooth takeoff (tiny at-a-glance sketch) ─────────────────────────────────
// A single accelerating curve starting visibly below human level and climbing
// past it (capability scale from simpleTakeoffLayout, 0.01× → 100×). No axis
// lines — dashed capability gridlines carry the structure; one red curve is
// the only strong ink. The curve is slightly accelerating from the very
// start (never flat, never plateauing) and keeps steepening through the
// right edge — the shape of the Plan D scenario's uplift curve.
//
// The shape is generated from the plain-English knobs in SMOOTH_CURVE
// (simpleTakeoffCurves.ts) — edit those to fine-tune, or use the live
// sliders on /figures-code. The `curve` prop exists only for that tuner.

export default function SimpleSmoothTakeoff({
  curve = SMOOTH_CURVE,
}: {
  curve?: SmoothCurveParams;
}) {
  return (
    <div className="mx-auto mt-4">
      <svg
        viewBox={`${VX} 0 ${VW} ${VH}`}
        className="w-full h-auto font-mono"
      >
        {LEVELS.map((lvl) => (
          <g key={lvl.lines.join(' ')}>
            <line
              x1={PLOT_L} y1={lvl.lineY} x2={PLOT_R} y2={lvl.lineY}
              stroke={FIG_INK} strokeWidth={0.75} strokeDasharray="2 3"
              opacity={lvl.lines[0] === 'Human' ? 0.55 : 0.32}
            />
            <text
              x={PLOT_L - 4}
              y={(lvl.labelY ?? lvl.lineY) + 2 - ((lvl.lines.length - 1) * LABEL_LH) / 2}
              textAnchor="end" fontSize={LABEL_FS} fill={FIG_TEXT}
            >
              {lvl.lines.map((ln, i) => (
                <tspan key={ln} x={PLOT_L - 4} dy={i === 0 ? 0 : LABEL_LH}>
                  {ln}
                </tspan>
              ))}
            </text>
          </g>
        ))}

        <path
          d={smoothTakeoffPath(curve)} fill="none" stroke={FIG_RED}
          strokeWidth={2.75} strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
